<div *ngIf="userProfile" class="nav-user-wrapper" (click)="onShowUserMenu()">
    <div class="nav-user-info">
        <div class="name">{{userProfile.firstName}}</div>
    </div>
    <div class="nav-avatar">
        <img class="avatar-img" *ngIf="optimizedProfileImgURL" [src]="optimizedProfileImgURL">
        <app-svg-loader *ngIf="!optimizedProfileImgURL" height="18px" url="assets/svg/user-solid.svg"></app-svg-loader>
        <span class="menu-cue" aria-hidden="true">
            <span></span>
            <span></span>
            <span></span>
        </span>
    </div>
</div>
<div [hidden]="!showUserMenu" class="nav-user-menu" #menu>
    <div class="user-account-row" *ngIf="userProfile && userProfile?.firstName">
        <div class="info">
            <div class="name">{{userProfile.firstName}} {{userProfile.lastName}}</div>
            <div class="email">{{userProfile.email}}</div>
        </div>
        <div class="avatar">
            <img class="avatar-img" *ngIf="optimizedProfileImgURL" [src]="optimizedProfileImgURL">
            <app-svg-loader *ngIf="!optimizedProfileImgURL" height="18px"
                url="assets/svg/user-solid.svg"></app-svg-loader>
        </div>
    </div>

    <ng-container *ngIf="!limited">

        <div class="menu-item" (click)="onClickMenuLink('/agent')">
            <div class="icon">
                <app-svg-loader height="14px" url="assets/svg/ai-circle.svg"></app-svg-loader>
            </div>
            My AI Agent
        </div>

        <div class="menu-item" (click)="onClickMenuLink('/watchers')">
            <div class="icon">
                <app-svg-loader height="14px" url="assets/svg/bookmark-check.svg"></app-svg-loader>
            </div>
            Currently Watching
        </div>

        <div class="menu-item" (click)="onClickMenuLink('/connections')">
            <div class="icon">
                <app-svg-loader height="14px" url="assets/svg/flight-shape-solid.svg"></app-svg-loader>
            </div>
            Flight Connections
        </div>

        <div class="menu-item" (click)="onClickMenuLink('/profile')">
            <div class="icon">
                <app-svg-loader height="14px" url="assets/svg/user-solid.svg"></app-svg-loader>
            </div>
            My Profile
        </div>

        <div class="menu-item" (click)="onClickMenuLink('/account')">
            <div class="icon">
                <app-svg-loader height="14px" url="assets/svg/settings-blobs.svg"></app-svg-loader>
            </div>
            Account & Subscription
        </div>

        <div class="menu-item" (click)="onClickMenuLink('/trusted-contacts')">
            <div class="icon">
                <app-svg-loader height="14px" url="assets/svg/user-solid.svg"></app-svg-loader>
            </div>
            Trusted Contacts
        </div>

        <div class="menu-item" (click)="onToggleTheme()">
            <div class="icon">
                <app-svg-loader *ngIf="currentTheme === 'dark-theme'" height="14px"
                    url="assets/svg/sun-solid.svg"></app-svg-loader>
                <app-svg-loader *ngIf="currentTheme === 'light-theme'" height="14px"
                    url="assets/svg/moon-solid.svg"></app-svg-loader>
            </div>
            <span *ngIf="currentTheme === 'dark-theme'">Light Theme</span>
            <span *ngIf="currentTheme === 'light-theme'">Dark Theme</span>
        </div>
    </ng-container>


    <div class="menu-item" (click)="onClickSignOut()">
        <div class="icon">
            <app-svg-loader height="14px" url="assets/svg/exit-solid.svg"></app-svg-loader>
        </div>
        Logout
    </div>

</div>
